import { useIntl } from 'react-intl';

import { FocusRingVariants } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';
import { SchoolSectionProps } from '@/components/schools/SchoolsLayout/types';

import messages from './messages';
import {
	Benefit,
	ContentWrapper,
	DesktopCtaButton,
	Grid,
	Heading,
	MobileCtaButton,
	Photo,
	Wrapper,
} from './styles';

const WhatYouGet = ({ onCtaClick }: SchoolSectionProps) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<Grid>
				<ContentWrapper>
					<Heading>{formatMessage(messages.heading)}</Heading>
					<Benefit>{formatMessage(messages.para1)}</Benefit>
					<Benefit>{formatMessage(messages.para2)}</Benefit>
					<Benefit>{formatMessage(messages.para3)}</Benefit>
					<DesktopCtaButton
						backgroundColor="schoolBlue"
						focusRingVariant={FocusRingVariants.Dark}
						onPress={() => onCtaClick(messages.heading.defaultMessage)}
					>
						{formatMessage(messages.button)}
					</DesktopCtaButton>
				</ContentWrapper>
				<Photo>
					<Image
						fill
						src="/_n/images/schools/what-you-get-photo.webp"
						alt="Woman teaching from home"
						style={{ objectFit: 'contain', objectPosition: 'center' }}
					/>
				</Photo>
				<MobileCtaButton
					backgroundColor="schoolBlue"
					onPress={() => onCtaClick(messages.heading.defaultMessage)}
				>
					{formatMessage(messages.button)}
				</MobileCtaButton>
			</Grid>
		</Wrapper>
	);
};

export default WhatYouGet;
